import React, { useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";
import WalletModal from "./walletModal"
import { useDispatch, useSelector } from "react-redux";
import {
  useWalletClient,
  useChainId,
  useDisconnect,
} from "wagmi";
import Web3 from "web3";
import $ from 'jquery';
import config from "../config/config";
import { setWallet } from "../reducers/Actions";
import { walletClientToSigner } from "../helper/getprovider";
import { formatNumber, shortText } from "../helper/custommath";

export default function InnerNavbar(props) {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const chain = useChainId();
  const { disconnect } = useDisconnect();
  const { data: walletClient } = useWalletClient({ chainId: config.network });

  const walletConnection = useSelector((state) => state.walletConnection);

  useEffect(() => {
    handleWalletConnection();
  }, [walletClient]);

  async function handleWalletConnection() {
    console.log(walletClient, walletClient && chain && parseInt(chain) === config.network, "walletClient");
    if (walletClient && chain && parseInt(chain) === config.network) {
      const { transport } = walletClientToSigner(walletClient);
      const web3 = new Web3(transport);
      const userAddr = walletClient.account?.address || "";

      const getBalance = await web3.eth.getBalance(userAddr);
      dispatch(
        setWallet({
          network: parseInt(chain),
          web3,
          address: userAddr,
          provider: transport,
          connect: "yes",
          balance: getBalance,
        })
      );
    } else {
      const fallbackNetwork = parseInt(localStorage.getItem("network")) || config.networkId;
      const web3 = new Web3(config.rpcURl);

      // if ((chain && parseInt(chain) !== config.network) || !chain) {
      //   if (["/dashboard", "/autopooliskd728jsnak382msmakncvae"].includes(location.pathname)) {
      //     navigate("/buytoken");
      //   }
      // }

      dispatch(
        setWallet({
          network: fallbackNetwork,
          web3,
          address: "",
          provider: "",
          connect: "no",
        })
      );
    }
  }

  function DisConnect() {
    disconnect();
    localStorage.clear();
    dispatch(
      setWallet({
        network: "",
        web3: "",
        address: "",
        provider: "",
        connect: "no",
      })
    );
    // navigate("/");
    $('.dropdown-menu').removeClass('show');
    $('#walletDropdown').attr('aria-expanded', 'false');
  }
 console.log("inerrrrrrrr");
  return (
    <>
      <nav class="navbar pb-3 nav_inner">
        <div class="container-fluid">
          <Link class="navbar-brand" to="/">
            <img
              src={require("../assets/images/logo.png")}
              alt=""
              className="img-fluid logo_img"
            />
          </Link>

          <div class=" d-flex justify-content-end" id="navbarSupportedContent">
            <div class="dropdown drop_box">
              {/* <a
                class="nav-link dropdown-toggle drop_head"
                href="#"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                12xu2....x987
              </a> */}
              {walletConnection && walletConnection.connect == "yes" && walletConnection.address != "" ? <>
                <Button
                  className="primary_btn me-2"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  class="nav-link dropdown-toggle drop_head"
                  href="#"
                > {shortText(walletConnection.address)} </Button>
              </> :
                <Button
                  className="primary_btn"
                  data-bs-toggle="modal"
                  data-bs-target="#exampleModal"
                >
                  Connect Wallet
                </Button>}
              <ul class="dropdown-menu">
                <li>
                  <a class="dropdown-item" href="#" onClick={() => DisConnect()}>
                    Logout
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </nav>
      <WalletModal />
    </>
  );
}
